import {
  AMap,
  BtnGroup,
  buildSubView,
  Em,
  MapItemContent,
  modalConfirm,
  NormalDist,
  playContext,
  roomImages,
  showMsg,
  TestPage,
  TItemData,
} from "@client";
import { Style } from "@client/style";
import { NpcModel } from "@npc";
import { calcScore, NumberUtil, SceneConst, SubNamespace } from "@share";
import { Button, Input, ModalFuncProps, Radio } from "antd";
import React, { useContext, useState } from "react";

function BuyHouseIntro6th() {
  const [n, setN] = useState(0),
    [v, setV] = useState(0);
  return (
    <div>
      6. 体验随机分布：你可通过点击以下【体验搜寻】按钮，体验钟爱程度【U】的（随机）变化。
      <table className={Style.tableInIntro}>
        <tbody>
          <tr>
            <td rowSpan={2}>
              第<Em>{n}</Em>次搜寻
            </td>
            <td>本次搜到的房屋的钟爱程度值为</td>
          </tr>
          <tr>
            <td>
              <Em>{v}</Em>万
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        房屋总价服从均值为<Em>{SceneConst.buyHouse.price.MEAN}万</Em>，标准差为
        <Em>{SceneConst.buyHouse.price.STD}万</Em>的<NormalDist />。
      </p>
      <p>
        你对房子的喜爱程度服从均值为
        <Em>{SceneConst.buyHouse.utility.MEAN}万</Em>
        ，标准差为
        <Em>{SceneConst.buyHouse.utility.STD}万</Em>的<NormalDist />。
      </p>
      <div style={{ margin: "1rem", textAlign: "right" }}>
        <Button
          className={Style.btnPrimarySm}
          onClick={() => {
            setN(n + 1);
            setV(NumberUtil.normalDist(SceneConst.buyHouse.utility));
          }}
        >
          体验搜寻
        </Button>
      </div>
    </div>
  );
}

function Play({ playDone }: { playDone: () => void }) {
  const {
    saveResult,
    params: { searchCost = 0 },
    playerState: { houseList },
  } = useContext(playContext);
  const { houses } = SceneConst.buyHouse;
  const [seenList, setSeenList] = useState(houses.map(() => false)),
    setSeen = (i: number) => {
      const _seenList = seenList.slice();
      _seenList[i] = true;
      setSeenList(_seenList);
    };
  const [depositedList, setDepositedList] = useState(houses.map(() => false)),
    setDeposited = (i: number) => {
      const _depositedList = depositedList.slice();
      _depositedList[i] = true;
      setDepositedList(_depositedList);
    };
  const [tradeIndex, setTradeIndex] = useState<number>(null!);
  const items: TItemData[] = houses.map(({ name }, i) => ({
    name,
    seen: seenList[i],
  }));
  const seeItem = (i: number) => {
    if (tradeIndex != null) {
      return;
    }
    const { houses } = SceneConst.buyHouse,
      { name } = houses[i];
    const seen = seenList[i],
      deposited = depositedList[i];
    const { price, discount, utility, deposit } = houseList[i];
    const confirmProps: ModalFuncProps = {
      onOk: async () => {
        let desc = "";
        if (!deposited) {
          setSeen(i);
          const range = NumberUtil.normalizeNormalDist(utility, SceneConst.buyHouse.utility),
            msg = {
              [NumberUtil.Range
                .I]: `符合你的住房要求，但并没有特别出众。周边环境有些不方便，有一个项目还在施工中，略显吵闹，但乐观估计总会越发展越好吧。`,
              [NumberUtil.Range.II]: `还是有潜力的。有交通线路可以直达工作地点，周边环境已有起色，房子大小刚合适！`,
              [NumberUtil.Range.III]: `真的不错哦！交通方便，周边环境较成熟，房子安静、舒适！`,
              [NumberUtil.Range.IV]: `非常适合你的口味！交通距离合适，周边生活方便，邻里团结友爱，应该是不二之选了！`,
            }[range];
          desc = `通过实地查看，你发现【${name}】${msg}通过综合评价，你对该房子的喜爱程度为【${utility}】万!`;
        }
        const modal = modalConfirm({
          title: name,
          okButtonProps: { hidden: true },
          cancelButtonProps: { hidden: true },
          maskStyle: {
            backgroundImage: `url('${roomImages[i]}')`,
            filter: "blur(.5rem)",
          },
          content: (
            <>
              <MapItemContent
                desc={desc}
                data={[
                  {
                    label: "价格",
                    value: `${price}万`,
                  },
                  {
                    label: "限时折扣价",
                    value: deposited || !seen ? `${(price - discount).toFixed(1)}万` : "无折扣",
                  },
                  {
                    label: "喜爱程度",
                    value: `${utility}万`,
                  },
                ]}
              />
              <BtnGroup>
                {deposited && <p style={{ fontSize: "1.5rem", margin: "1rem" }}>已预订</p>}
                <Button className={Style.btnWarningSm} onClick={() => modal.destroy()}>
                  返回
                </Button>
                {deposited || (
                  <>
                    <Button
                      className={Style.btnPrimarySm}
                      onClick={() => {
                        const confirmProps: ModalFuncProps = {
                          okText: "支付",
                          onOk: () => {
                            setDeposited(i);
                            modal.destroy();
                            showMsg(`成功在【${name}】预订下满意的户型`);
                          },
                          width: "48rem",
                          content: (
                            <div>
                              将支付<Em>{deposit}万</Em>
                              订金准备购买这套房子？
                            </div>
                          ),
                        };
                        modalConfirm(confirmProps);
                      }}
                    >
                      预订
                    </Button>
                  </>
                )}
                <Button
                  className={Style.btnPrimarySm}
                  onClick={async () => {
                    modal.destroy();
                    setTradeIndex(i);
                    const earning = (utility - price).toFixed(1);
                    const totalSearchCost = seenList.map((seen) => (seen ? searchCost : 0)).reduce((m, n) => m + n);
                    const buyHouse_depositCost = depositedList
                      .map((deposited, j) => (j !== i && deposited ? houseList[j].deposit : 0))
                      .reduce((m, n) => m + n);
                    await showMsg(
                      <p>
                        花费<Em>{totalSearchCost}</Em>的搜寻成本
                        {buyHouse_depositCost > 0 && (
                          <>
                            并放弃<Em>{buyHouse_depositCost.toFixed(1)}万</Em>
                            的订金
                          </>
                        )}
                        后， 你本轮以
                        <Em>{deposited ? price - discount : price}万</Em>
                        的价格买下
                        <Em>{name}</Em>
                        的房子，获得收益
                        <Em>{earning}万</Em>，恭喜你！
                      </p>,
                      {
                        okText: "知道了",
                      }
                    );
                    const utilityList = houseList.map((h) => h.utility);
                    saveResult({
                      score: calcScore(NumberUtil.getMin(utilityList), utilityList[i], NumberUtil.getMax(utilityList)),
                      seenList,
                      depositedList,
                      tradeIndex,
                    });
                    playDone();
                  }}
                >
                  购买
                </Button>
              </BtnGroup>
            </>
          ),
        });
      },
      cancelText: "取消",
      content:
        !deposited && searchCost ? (
          <p>
            你选择了
            <Em>{name}</Em>，是否支付
            <Em>{searchCost}</Em>元的搜寻成本查看住所信息?
          </p>
        ) : (
          <p>
            你选择了
            <Em>{name}</Em>，本次搜寻无成本。
          </p>
        ),
    };
    modalConfirm(confirmProps);
  };
  return <AMap items={items} onClick={(i) => seeItem(i)} />;
}

function Test({ done }: { done: (answers, answerScores) => void }) {
  return (
    <TestPage
      questions={[
        {
          Content: ({ inputProps }) => (
            <div>
              <p>当买家预期市场价格持续上涨时，买家的搜寻成本包括了价格波动造成的损失，因此，买家更倾向于搜寻。</p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A. 正确</Radio>
                <Radio value={2}>B. 错误</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => (
            <p>
              价格持续上涨时，消费者预期未来价格更高，因此倾向于减少搜寻；价格持续下跌时，消费者预期未来价格更低，因此倾向于增加搜寻。
            </p>
          ),
          answer: [2],
        },
        {
          Content: ({ inputProps }) => (
            <div>
              <p>
                卖家在使用销售策略时，可能会同时采用多种策略。比如，卖家可以要求买家支付定金【d】的前提下获得限时优惠，以价格【p_d】购买产品。考虑这样一个产品市场：买家预期有50%的机会获得货币效用3000,50%的机会获得货币效用1500元。卖家设置的原价格为1200元，同时卖家承诺，如果预交定金200元，可以“200元抵用400元”，也就是以800+200=1000元的价格买到该产品。搜寻成本为200元。则该买家是否应该使用定金：
              </p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A. 使用定金+优惠</Radio>
                <Radio value={2}>B. 不使用定金+优惠</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => (
            <p>
              搜寻+定金：（3000-1000-200）*0.5+（1500-1000-200）*0.5=1050
              <br />
              搜寻+不加定金：（3000-1200-200）*0.5+（1500-1200-200）*0.5=850
            </p>
          ),
          answer: [1],
        },
        {
          isAnalysis: true,
          Content: ({ inputProps }) => (
            <div>
              <p>
                你认为卖家在现实生活中综合使用了哪些阻止消费者搜寻的手段？本题为主观题，无正确的答案，只需说明理由。
              </p>
              <br />
              <Input.TextArea maxLength={2e3} rows={4} {...inputProps({ width: "100%" })} />
            </div>
          ),
        },
      ]}
    />
  );
}

export const BuyHouseView = buildSubView({
  namespace: SubNamespace.BuyHouse,
  npcModel: NpcModel.RentHouse,
  label: "买房",
  withSearch: true,
  npcWelcome: async () => {
    await showMsg("恭喜你！我们可以在城市里定居了！请开始搜索一个中意的房子吧！");
  },
  introMsg: () => {
    return [
      ...`1.\t你需要买一套房子。
2.\t你对房子总价的目标是【${SceneConst.buyHouse.price.MEAN}万】。经过初步筛查，你选出了【${SceneConst.buyHouse.houses.length}】个备选项，他们的标准差为【${SceneConst.buyHouse.price.STD}万】。
3.\t你可从这些备选房屋中，逐个搜寻让你满意的住所。你在搜寻过程中会产生成本：每次搜寻需要花费【S】元。
4.\t你对房子的钟爱程度【U】受到地段、周边、邻里、设施等多维度的影响。只有访问具体的房子，你才能得到汇总得分【U】。
5.\t经过了前期的调研，你对该地区的房子有了大致的了解。你估计备选房屋的【Ubar】，标准差为【StdU】,你备选搜寻的房子的【钟爱程度】呈正态分布在各区间之内。
`
        .trim()
        .split("\n"),
      <BuyHouseIntro6th />,
      `7.\t在该任务中开发商会收取【定金】，也会采用【限时优惠】。`,
      <p>
        8. 你可以通过点击【图标
        <span
          style={{
            display: "inline-block",
            width: "2.5rem",
            height: "2.5rem",
            background: "url(/MarketSearch/static/asset/img/poi-marker.png) 0 -2.5rem / 27rem no-repeat",
          }}
        />
        】 获得该住所的方便程度【U】。你需要决定是否接受住所的报价，或者继续搜寻。
      </p>,
      `9.\t你可以【直接购买】或者【支付定金】并后续购买。你也可以放弃定金，购买其它产品。`,
    ];
  },
  Play,
  Test,
  initState: (s) =>
    (s.houseList = SceneConst.buyHouse.houses.map(() => ({
      price: NumberUtil.normalDist(SceneConst.buyHouse.price, 1),
      deposit: NumberUtil.uniformDist(SceneConst.buyHouse.deposit, 1),
      discount: NumberUtil.uniformDist(SceneConst.buyHouse.discount, 1),
      utility: NumberUtil.normalDist(SceneConst.buyHouse.utility, 1),
    }))),
});
